import en from './en'
import zh from './zh'
import lw from './laowo'
import meng from './meng'
import tai from './tai'
export default {
  en,
  zh,
  lw,
  tai,
  meng,
}